module.exports = __webpack_public_path__ + "media/icons/arrows-2fdd5307.png";